class NonomicIngredientsModal extends HTMLElement {
  constructor() {
    super();
    this.opened = false;
    this.entering = false;
    this.boundKeyup = this.onKeyup.bind(this);
    this.boundTriggerClick = this.onTriggerClick.bind(this);
    this.boundSectionSelect = this.onSectionSelect.bind(this);
    this.boundSectionDeselect = this.onSectionDeselect.bind(this);
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);

    this.backdrop = this.querySelector('[data-nim-backdrop]');
    this.dialog = this.querySelector('[data-nim-dialog]');

    this.querySelectorAll('[data-nim-close]').forEach((el) => {
      el.addEventListener('click', () => this.close());
    });

    if (this.backdrop) {
      this.backdrop.addEventListener('click', (event) => {
        if (event.target === this.backdrop) this.close();
      });
    }

    this.addEventListener('keyup', this.boundKeyup);
    document.addEventListener('click', this.boundTriggerClick);

    if (typeof Shopify !== 'undefined' && Shopify.designMode) {
      document.addEventListener('shopify:section:select', this.boundSectionSelect);
      document.addEventListener('shopify:section:deselect', this.boundSectionDeselect);
    }
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.boundTriggerClick);

    if (typeof Shopify !== 'undefined' && Shopify.designMode) {
      document.removeEventListener('shopify:section:select', this.boundSectionSelect);
      document.removeEventListener('shopify:section:deselect', this.boundSectionDeselect);
    }
  }

  onTriggerClick(event) {
    const trigger = event.target.closest('[data-nonomic-ingredients-modal-open]');
    if (!trigger) return;

    const targetId = trigger.getAttribute('data-nonomic-ingredients-modal-target');
    if (targetId && targetId !== this.id) return;

    event.preventDefault();
    this.open();
  }

  onKeyup(event) {
    if (event.code === 'Escape' && this.opened) this.close();
  }

  onSectionSelect(event) {
    if (event.detail.sectionId === this.dataset.sectionId) this.open({ force: true });
  }

  onSectionDeselect(event) {
    if (event.detail.sectionId === this.dataset.sectionId) this.close({ immediate: true });
  }

  open(options = {}) {
    if (this.opened && !options.force) return;

    this.opened = true;
    this.removeAttribute('hidden');
    this.setAttribute('aria-hidden', 'false');
    document.body.classList.add('overflow-hidden');

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.entering = true;
        this.classList.add('is-open', 'is-entering');
        this.dialog?.focus();
      });
    });
  }

  close(options = {}) {
    if (!this.opened) return;

    if (options.immediate) {
      this.finishClose();
      return;
    }

    this.entering = false;
    this.classList.remove('is-entering');

    window.setTimeout(() => this.finishClose(), 280);
  }

  finishClose() {
    this.opened = false;
    this.entering = false;
    this.classList.remove('is-open', 'is-entering');
    this.setAttribute('hidden', '');
    this.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('overflow-hidden');
  }
}

if (!customElements.get('nonomic-ingredients-modal')) {
  customElements.define('nonomic-ingredients-modal', NonomicIngredientsModal);
}
